import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { RoomLayout as RoomLayoutEnum } from '../../../enums/RoomLayout';
import { RoomSchema } from '../../../definitions/schemas';
import { useI18n } from '../../../lib/hook/useI18n';
import RoomAppBar from '../../Rooms/RoomAppBar';
import RoomLayout from '../Layout/RoomLayout';

interface Props {
  primaryText: React.ReactNode;
  retry?: boolean;
  room: RoomSchema | undefined;
  secondaryText?: React.ReactNode;
}

const RoomEmptyState: React.FC<Props> = (props: Props): JSX.Element => {
  const { t } = useI18n();

  const { primaryText, retry, room, secondaryText } = props;

  /**
   * We're basically mocking all components except the app bar and contents here,
   * as there's nothing else to show in this empty state
   */
  const renderMockedRoomComponent = () => null;

  return (
    <RoomLayout
      disableRoomSummary
      layout={RoomLayoutEnum.Story3Columns}
      renderActionPlans={renderMockedRoomComponent}
      renderBanner={renderMockedRoomComponent}
      renderBeforeContent={renderMockedRoomComponent}
      renderBusinessCard={renderMockedRoomComponent}
      renderCommunicationActions={renderMockedRoomComponent}
      renderName={renderMockedRoomComponent}
      renderSalesActions={renderMockedRoomComponent}
      renderSectionHeaders={renderMockedRoomComponent}
      renderSignables={renderMockedRoomComponent}
      renderWelcomeMessage={renderMockedRoomComponent}
      renderAppBar={() => (
        <RoomAppBar
          centeredLogos
          clientLogo={room?.clientLogoUrl || room?.clientLogoUri}
          organization={room?.organization}
        />
      )}
      renderContents={() => (
        <Box pt={8} textAlign="center">
          <Typography color="textPrimary" variant="body1">
            {primaryText}
          </Typography>
          {secondaryText && (
            <Typography color="textSecondary" variant="body2">
              {secondaryText}
            </Typography>
          )}
          {retry && (
            <Box mt={1}>
              <Button
                color="secondary"
                onClick={() => window.location.reload()}
                variant="outlined"
              >
                {t('room.retry.button')}
              </Button>
            </Box>
          )}
        </Box>
      )}
      RoomContainerProps={{ disableFooter: true }}
    />
  );
};

export default RoomEmptyState;
